﻿import { ReactNode, RefObject } from 'react';

export type DsSliderProps = {
  children: ReactNode
  nextButton?: ButtonRef
  previousButton?: ButtonRef
  className?: string
  slideBy?: number
  touchMode?: TouchMode
  maxGroupSize?: number
  buttonDisabledClasses?: string
  onGroupSizeChange?: FnWithNumberInput;
  beforeChange?: FnWithNumberInput
  afterChange?: FnWithNumberInput;
  enableTestAttributes?: boolean
  navClickEasingFunction?: EasingFunction;
  touchEasingFunction?: EasingFunction;
  touchTransitionDuration?: TransitionDuration
  navClickTransitionDuration?: TransitionDuration
  touchAngleThreshold?: number
}

export type DsSliderHandle = {
  goToSlide: (index: number) => void;
}

export type Tiles = RefObject<Array<HTMLDivElement | null>>;

export type ButtonRef = RefObject<HTMLButtonElement | null>;

export type FnWithNumberInput = (x: number) => void;

export type TransitionDuration = `${number}${'s' | 'ms'}`

export type EasingFunction = `cubic-bezier(${number}, ${number}, ${number}, ${number})` | 'linear' | `linear(${number}, ${number}, ${number})` | 'ease' | 'ease-in' | 'ease-out' | 'ease-in-out' | 'step-start' | 'step-end' | `steps(${number}, ${'jump-start' | 'jump-end' | 'jump-none' | 'jump-both' | 'start' | 'end'})`;

export type TouchMode = 'glide' | 'gesture' | 'disable'

export type TouchRecord = {
  time: number
} & Coordinate;

export type Coordinate = {
  x: number;
  y: number
};

export type PositiveNumber = number & {__brand: 'PositiveNumber'}

export function assertPositiveNumber(x: number): asserts x is PositiveNumber {
  if (x < 0) {
    throw new Error(`Number '${x}' must be positive`);
  }
}